import { render, staticRenderFns } from "./account.view.vue?vue&type=template&id=3f20c883&scoped=true"
import script from "./account.view.vue?vue&type=script&lang=ts"
export * from "./account.view.vue?vue&type=script&lang=ts"
import style0 from "./account.view.vue?vue&type=style&index=0&id=3f20c883&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20c883",
  null
  
)

export default component.exports